module.exports = __webpack_public_path__ + "static/media/female-icon.c66859c5.png";